import { EventNameTypes, makeSegmentTrackCall } from 'client/javascript/analytics';

function trackSavingEvent(isUnsavedToSaved, uuid, type, containerClass) {
  const props = {
    label: 'Save Event',
    saveStatus: isUnsavedToSaved ? `Saved a ${type}` : `Unsaved a ${type}`,
    uuid,
    containerClass
  };

  makeSegmentTrackCall(EventNameTypes.interaction, props);
}

export function savedPageEvent(numberOfBuildingsInCookie) {
  const props = {
    label: 'Accessed Saved page',
    savedBuildingCount: numberOfBuildingsInCookie
  };

  makeSegmentTrackCall(EventNameTypes.page, props);
}

export function trackSavingBuildingEvent(isUnsavedToSaved, uuid, containerClass) {
  trackSavingEvent(isUnsavedToSaved, uuid, 'building', containerClass);
}
